import { getSettlementUnits } from '@/api/settlementUnit';
import moment, { Moment } from 'moment';
import { isOverTime } from './other';

type ISettlementUnitInfo = ISettlementUnit.IResponse.ISettlementUnitInfo;
let allSettlementUnits: ISettlementUnitInfo[] = [];
let loadedTime: Moment | null = null;

export const getAllSettlementUnits = (
  force: boolean = false,
): Promise<string> => {
  return new Promise((resolve, reject) => {
    const minute = force ? -1 : 3;
    if (!isOverTime(loadedTime, minute)) {
      resolve('');
      return;
    }
    getSettlementUnits({ active: true })
      .then((res) => {
        allSettlementUnits = res.data;
        loadedTime = moment();
        resolve(res.message);
      })
      .catch((err) => {
        reject(err.message);
      });
  });
};
export const filterSettlementUnits = (key: keyof ISettlementUnitInfo, value: any) => {
  return allSettlementUnits.filter((unit) => unit[key] === value);
};
